<template>
  <div v-if="showAlarms" class="card-alarm pt-2 pl-2 pr-2" flat @click="dialog = true">
    <span
      v-if="!loading"
      class="d-flex justify-space-between align-items a-title gray--text mb-1"
      >Alarmes
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            size="21px"
            v-bind="attrs"
            v-on="on"
            class="mr-2"
            color="grayLight"
            >schedule</v-icon
          >
        </template>
        <span class="a-text">Última atualização: </span>
        <span>{{ updatedTime }}</span>
      </v-tooltip>
    </span>
    <v-skeleton-loader v-else type="text" width="80px" />
    <AlarmsIcons class="alarm-icons" :loading="loading" :alarms="total" />
    <v-dialog v-model="dialog" width="850px">
      <ModalAlarms @close="dialog = false" :reference="reference" />
    </v-dialog>
  </div>
</template>

<script>
import AlarmsIcons from "./AlarmsIcons.vue";
import ModalAlarms from "./ModalAlarms.vue";
import { validateObject } from "@/models/Utils";
import { alarmMixin } from "@/services/alarms/mixin.js";
import {mapGetters} from 'vuex'
export default {
  name: "CardAlarms",
  mixins: [alarmMixin],

  components: {
    AlarmsIcons,
    ModalAlarms,
  },
  props: {
    reference: Object,
  },
  data() {
    return {
      dialog: false,
      total: {},
      loading: true,
      setInterval: undefined,
    };
  },
  watch: {
    alarmsReceived() {
      this.handlePlantChanges();
    },
    reference() {
      this.loading = true;
      this.handlePlantChanges();
    },
  },
  computed:{
    ...mapGetters(["showAlarms"])
  },
  methods: {
    async handlePlantChanges() {
      let id = ["all"];
      if (this.reference) {
        if (validateObject(this.reference, "plantsId")) {
          id = this.reference.plantsId.length ? this.reference.plantsId : id;
        } else {
          id = [this.reference.id];
        }
      }
      this.total = await this.$store.dispatch("getTotal", {
        id,
        plantId: false,
      });
      if (this.total) {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },
  },
};
</script>

<style scoped>
.card-alarm {
  min-height: 70px;
  background: white;
  border-radius: 4px;
  cursor: pointer;
}
.alarm-icons {
  display: flex;
  height: 60%;
  align-items: center;
}
</style>